import axios from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_REACT_API_URL,
});

// const noRote = [
//   "/login"
// ]

api.interceptors.request.use(
  (config) => {
    if (config?.headers?.withoutAuth === true) {
      return config;
    }
    const { token } = JSON.parse(localStorage.getItem("token") || "{}");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;

  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
